module.exports = "/_next/static/images/electrum-86ba59b3b854b15457449828199ea08c.png";